<template>
    <div class="progress">
        <h2 :style="styles.title">
            {{ percentage }}%
        </h2>
        <div class="bar">
            <div class="fill" :style="styles.bar"/>
        </div>
    </div>
</template>
<script>
import Colorable from '../../mixins/Colorable';

export default {
    name: 'Progress',
    mixins: [Colorable],
    props: {
        value: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        percentage () {
            return Math.round(100 * this.value);
        },
        styles () {
            return {
                title: {
                    color: this.color,
                },
                bar: {
                    width: `${this.percentage}%`,
                    backgroundColor: this.color,
                },
            };
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

.progress {
    > h2 {
        text-align: center;
    }

    > .bar {
        border-radius: 10px;
        overflow: hidden;
        height: 10px;
        margin: 0 auto;
        background-color: $grey-lightest;

        > .fill {
            height: inherit;
            border-radius: inherit;
            transition: width .3s ease-in-out;
        }
    }
}
</style>
